<template>
  <client-only>
    <RmCheckboxGroup
      :checkboxes="filtersWithCount"
      :checked="checked"
      @change-item="handleChange"
    />
  </client-only>
</template>

<script>
import RmCheckboxGroup from '~/components/shared/rm_checkbox_group.vue'
export default {
  components: {
    RmCheckboxGroup,
  },
  props: {
    possibleFilters: {
      type: Array,
      default: () => [],
    },
    checked: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: '',
    },
  },
  setup () {
    const search = useSearch()
    const searchForm = useSearchForm()
    return {
      searchForm,
      getFilterById: search.getFilterById,
    }
  },
  computed: {
    filtersWithCount () {
      return this.possibleFilters.map(item => {
        const newItem = { ...item.filterItem }
        newItem.count = item.lotsCount || item.lotCount || 0
        if (item.node?.avgRating) {
          newItem.meta = { rating: item.node.avgRating }
        }
        return newItem
      })
    },
  },

  methods: {
    handleChange (value, fullValue) {
      this.searchForm.setIsChangedParams(true)
      this.searchForm.setChangedFilter({
        action: value.checked,
        id: this.getFilterById(fullValue.id).keyId,
        name: this.getFilterById(fullValue.id).keyName,
        type: 'CHECKBOX',
        valueId: this.getFilterById(fullValue.id).id,
        valueName: this.getFilterById(fullValue.id).name,
      })

      if (value.checked) {
        this.searchForm.addFilter(value.id)
      } else {
        this.searchForm.removeFilter(value.id)
      }
    },
  },
}
</script>
